// 页面配置权限
import store from '../vuex/store.js' 
function hasPermission (perms) {
  let hasPermission = false;
  let permission = [];
  if(JSON.stringify(store.state.userInfo)!={}&&localStorage.getItem('userInfo')){
    permission = JSON.parse(localStorage.getItem('userInfo')).permission.split(',');
    for (var i = 0; i < permission.length; i++) {
      if(permission[i] === perms){
        hasPermission = true;
        break;
      }
    }
  }
  return hasPermission;
}
// array快速排序
const quickSort = arr => {
  const a = [...arr];
  if (a.length < 2) return a;
  const pivotIndex = Math.floor(arr.length / 2);
  const pivot = a[pivotIndex];
  const [lo, hi] = a.reduce(
    (acc, val, i) => {
      if (val < pivot || (val === pivot && i != pivotIndex)) {
        acc[0].push(val);
      } else if (val > pivot) {
        acc[1].push(val);
      }
      return acc;
    },
    [[], []]
  );
  return [...quickSort(lo), pivot, ...quickSort(hi)];
};
// /** 数组排序
//  *@param prop 属性字段
//  *@returns 排序后的数组 {Array}
//  */
function keySort (prop){ 
  return function (obj1, obj2) {
    var val1 = obj1[prop];
    var val2 = obj2[prop];
    if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
        val1 = Number(val1);
        val2 = Number(val2);
    }
    if (val1 > val2) { //升序排列
        return 1;
    } else if (val1 < val2) {
        return -1;
    } else {
        return 0;
    }
  }         
}
function cshQian() {
  for (var i in this.$systemValue) {
    var showHelp = {};
    for (var m of this.$systemValue[i]) {
      m.id = String(m.id);
      if (localStorage.getItem('languageType') == 0) {
        m.showText = m.ch;
      } else if (localStorage.getItem('languageType') == 1) {
        m.showText = m.en;
      }
      showHelp[m.id] = m.showText
    }
    this.$store.state[i] = this.$systemValue[i];
    this.$store.state[i + 'Help'] = showHelp;
  }
}

function isMobile() {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag) {
      return true
    } else {
      return false
    }
  }
export default {
  hasPermission,
  quickSort,
  keySort,
  cshQian,
  isMobile
}



// WEBPACK FOOTER //
// ./src/utils/util.js